/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ManagePoi.scss';

import { updatePoi, deletePoi, savePoi } from '../../../../../actions/postGeoData';

const fastStyleMargin = {
  marginTop: '7px',
};

const fullWidth = {
  width: '100% !important',
};

// featre properties are list, here's each list element name
// id,kategoria, typ, nazwa_pelna, opis, opis_pelny, kod_pocztowy,miejscowosc,ulica,nr_budynku,telefon,email,strona_www,czas_otwarcia,wlasnosc
// nr_lokalu, dlugosc_geogr, szerokosc_geogr, symbol,x,y from gmina_cieszanow.ob_turyst_pkt

const propertyNames = ['id', 'kategoria', 'typ', 'nazwa_pelna', 'opis', 'opis_pelny', 'kod_pocztowy', 'miejscowosc', 'ulica', 'nr_budynku',
                      'telefon', 'email', 'strona_www', 'czas_otwarcia', 'wlasnosc', 'nr_lokalu',
                      'dlugosc_geogr', 'szerokosc_geogr', 'symbol', 'x', 'y' ];
const propertyDisplayableNames = ['id', 'Kategoria', 'Typ', 'Pełna nazwa', 'Opis', 'Pełny opis', 'Kod pocztowy', 'Miejscowość', 'Ulica', 'Nr budynku',
                      'Telefon', 'email', 'Strona www', 'Godziny pracy', 'Własność', 'Nr lokalu',
                      'Dlugość geograficzna', 'Szerokość geograficzna', 'Symbol', 'x', 'y' ];
const notAllowedIndexes = [0, 16, 17, 19, 20]

class ManagePoi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editedFeatures: [],
    };
  }

  deleteFeature = (id) =>{
    this.props.deletePoi(this.props.district.prefix, id)
    .then(resp => {
      console.info("pomyślnie usunięto poi");
    });
  }
  editFeature = (feature) => {

    // let mappedFeature = {};
    // Object.keys(feature.properties).map((v, i) => {
    //   mappedFeature[propertyDisplayableNames[i]] = v;
    // });
    let currentState = this.state.editedFeatures.slice();
    _.map(currentState, 'id').indexOf(feature.id) >= 0 ? currentState.pop(feature) : currentState.push(feature);
    this.setState({ editedFeatures: currentState });
  }
  acceptFeature = (id) =>{
    this.props.savePoi(this.props.district.prefix, id)
  }
  saveFeatureEditFeature = (feature) => {
    let rewritedFeatureKeys = {}
    for (const i in Object.keys(feature)){
      const key = Object.keys(feature)[i];
      const val = feature[key];
      rewritedFeatureKeys[propertyNames[i]] = val;
    }
    this.props.updatePoi(this.props.district.prefix, rewritedFeatureKeys)
    .then(resp => {
      let currentState = this.state.editedFeatures.slice();
      currentState.pop(feature);
      this.setState({ editedFeatures: currentState });
    });
  }

  onEditFeature = (e, feature, property) => {
    feature.properties[property] = e.target.value;
    let currentState = this.state.editedFeatures.slice();
    currentState.pop(_.find(currentState, (o) => o.id === feature.id));
    currentState.push(feature);
    this.setState({ editedFeatures: currentState });
  }

  render() {
    return this.props.new_pois.data ? (
      <div className="col-xs-12">
        <div className="row">
          <div className="col-sm-3">Kategoria</div>
          <div className="col-sm-3">Typ</div>
          <div className="col-sm-3">Pełna nazwa</div>
          <div className="col-sm-3">Akcje</div>
          <hr className="style-one" />
        </div>
        {this.props.new_pois.data.features.map((value) => {
          let feature = _.find(this.state.editedFeatures, (o) => o.properties.id === value.properties.id);
          return (
            <div className="row" key={value.properties.id}>
              <div className="col-sm-12">
                <div className="col-sm-3">{value.properties.kategoria}</div>
                <div className="col-sm-3">{value.properties.typ}</div>
                <div className="col-sm-3">{value.properties.nazwa_pelna}</div>

                {/* buttons should be visible only when we're not editing feature */}
                {!feature ? (
                  <div className="col-sm-3">
                    <button type="button" className="btn btn-danger" onClick={() => this.deleteFeature(value.properties.id)}>Usuń</button>
                    <button type="button"className="btn btn-warning" onClick={() => this.editFeature(value)}>Edytuj</button>
                    <button type="button"className="btn btn-primary" onClick={() => this.acceptFeature(value.properties.id)}>Akceptuj</button>
                  </div>
                ) : <div className="col-sm-3" /> }

              </div>
              <div className={_.find(this.state.editedFeatures, (v, i) => v.properties.id === value.properties.id) ? 'col-sm-12' : 'dont-display-feature-edition'}>
                <div className="row">
                  <div className="col-sm-12">
                    <hr className="style-two" />
                  </div>
                  {feature && Object.keys(feature.properties).map((v, i) => {

                    return feature && notAllowedIndexes.indexOf(i) === -1 ? (
                      <div className="col-sm-12" key={i}>
                        <div className="form-group">
                          <label className="control-label col-xs-2">{propertyDisplayableNames[propertyNames.indexOf(v)]}</label>
                          <div className="col-xs-6">
                            <input
                              className="form-control"
                              name={v}
                              onChange={(e) => this.onEditFeature(e, feature, v)}
                              value={feature.properties[v] ? feature.properties[v] : ''}
                            />
                          </div>
                        </div>
                      </div>
                    ) : null;
                  })}
                  <div className="col-xs-4">
                    <button type="button" className="btn btn-danger" onClick={() => this.editFeature(value)}>Anuluj</button>
                    <button type="button" className="btn btn-primary" onClick={() => this.saveFeatureEditFeature(feature)}>Zapisz zmiany</button>
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <hr className="style-two" />
              </div>
            </div>
          );
        })}
      </div>
    ) : <h3>Brak zgłoszonych punktów poi</h3>;
  }
}

const mapState = (state) => ({
  district: state.district.district,
  new_pois: state.postGeoData.additionalLayers.pois_propozycje,
});
const mapDispatch = {
  updatePoi,
  deletePoi,
  savePoi,
};

export default withStyles(s)(connect(mapState, mapDispatch)(ManagePoi));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/ManagePoi/ManagePoi.js